 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		392: 0,
 		279: 0,
 		280: 0,
 		290: 0,
 		339: 0,
 		340: 0,
 		348: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","216":"AddClosedAlertIDUseCase","217":"CreateDeviceUseCase","218":"CreateDomestikaFollowUseCase","219":"CreateJWTUserUseCase","220":"CreateUserLiveSessionUseCase","221":"CurrentUserUseCase","222":"CurrentWithoutRelationshipsUserUseCase","223":"DeleteDeviceUseCase","224":"DeleteFollowUseCase","225":"ENV_CONFIG1","226":"ENV_CONFIG4","227":"ENV_CONFIG5","228":"ENV_CONFIG6","229":"ENV_CONFIG7","230":"FinishUserLiveSessionUseCase","231":"GetAccessTokenUserUseCase","232":"GetAdvanceGDPRStatusUserUseCase","233":"GetAllBlogUseCase","234":"GetAreasCourseUseCase","235":"GetCartCourseUseCase","236":"GetCategoriesCourseUseCase","237":"GetCourseUseCase","238":"GetFinalProjectVideoByCourseIDCourseUseCase","239":"GetGDPRStatusUserUseCase","240":"GetListLiveFeedbackQuestionUseCase","241":"GetListLiveSessionUseCase","242":"GetListLiveStreamUseCase","243":"GetLiveChannelUseCase","244":"GetLiveSessionUseCase","245":"GetOrganizationUseCase","246":"GetPlusPromotionUseCase","247":"GetPostContentBlogUseCase","248":"GetPromotionCodeAlertUseCase","249":"GetPromotionUseCase","250":"GetPubnubCredentialsUseCase","251":"GetSessionDataUserUseCase","252":"GetSimpleUserUseCase","253":"GetSoftwaresCourseUseCase","254":"GetUserAlertUseCase","255":"GetVideoProgressListCourseUseCase","256":"GetVideoSpeedUserUseCase","257":"GetVideoVolumeUserUseCase","258":"LogoutUserUseCase","259":"PathToRegexp","260":"RefreshAccessTokenUserUseCase","261":"RemoveAccessTokenUserUseCase","262":"SearchCourseUseCase","263":"SendHeaderTrackingUseCase","264":"SendLiveFeedbackAnswersUseCase","265":"SendPlayerTrackingUseCase","266":"SendTrackingUseCase","267":"SendVideoProgressCourseUseCase","268":"SetAdvanceGDPRStatusUserUseCase","269":"SetGDPRStatusUserUseCase","270":"SetVideoSpeedUserUseCase","271":"SetVideoVolumeUserUseCase","272":"UpdateLanguageUserUseCase","273":"UpdateLiveSessionUseCase","274":"UpdateVideoAudioAndSubtitlesCourseUseCase","275":"UpdateVideoProgressCourseUseCase","276":"ViewPageTrackingUseCase","347":"vendors~AddClosedAlertIDUseCase","348":"vendors~AmplitudeJS","349":"vendors~SearchCourseUseCase","350":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"6e23d8beb312bd481e32","1":"8ffa20e7042e03a7d631","2":"8ce276b4df8b6c4aaeef","3":"83b0714c5de6f1147133","4":"1f9cb58bc8c0978350d4","5":"a2450219d9778223aa80","215":"dfc814de2c6e78841fb1","216":"29ed3003fb2594e5085a","217":"d85802bbb8374b9755f2","218":"241af880beb87466d9a1","219":"2290b792f6318303d51e","220":"33b34acfbd94a32712fa","221":"8fa7cac2d7939ecf9ca7","222":"f5c3b87c8ebf439f5ca5","223":"19ea414aa26a02cec734","224":"d4b92246decc4d9864e8","225":"81c334176044deb750d5","226":"313a0dadd5bff9c5493a","227":"beba24b886a785ce8159","228":"5386dcff49edd6db7717","229":"9954f577042a847d3529","230":"d7cfbbaa5618c27287d0","231":"3f30520c48ce6b8e3d27","232":"bc1c327a56fe88c17a87","233":"9c6175ab40dd892e1ab9","234":"bbb6106f332fed5c4d34","235":"57c0ed6d5fa0ef9a3eae","236":"46d825f99a2239487f9f","237":"34ca8e44788a7c4f92de","238":"734266fbb2d14f8fa36f","239":"cfc2e28e8f4f8283f7f5","240":"6f2ff8514dba65ff351d","241":"4570f165822342b7b859","242":"73e45465163b4ca9ee06","243":"2e2ea6f0ef53e0287f84","244":"fea3e2d003574341777e","245":"d8cc77668d0a862fb093","246":"df2569a7626e0f8397a1","247":"fe895fef82f17a28e0c2","248":"a954938b7679ebfea12a","249":"2c93dae1cf6647a8e29e","250":"19015d213fa31d439602","251":"c1f1e59190390f73206e","252":"cfe8eeb2375fd02ea57c","253":"5b2c2762b93bfd7d4eef","254":"1ed050200f961aa31fa1","255":"c7442751ede285339d6f","256":"c69933ff319c8701b4c1","257":"1e0b3710b230259262a4","258":"9b4008ddbdae57f1a9fb","259":"abb606ee1578341363a8","260":"f12c81a253961c07d6d4","261":"44d7d4c4a6966dabf3b0","262":"e9bc071817393674333b","263":"d529bd49d12254d49002","264":"013414c47a10af075bad","265":"cd05920922d96e5681c8","266":"28eab4024254a8b80e78","267":"51a4c9056c425b3537b2","268":"78921e3538fe8528db9b","269":"027348f83212ab0d9bc2","270":"3fa26ed2bf8bfe20f20a","271":"bf2794a9d3ff61a66428","272":"7a1f8312fb0ee8e30a4a","273":"b44a98be74ca9c99c548","274":"510db38f25a2ab522537","275":"ec4d335cd59366f14551","276":"cf9bc33bacb5502c05a4","347":"fbfd64d86ae0457e38ad","348":"7e06dd855121b53eab9c","349":"06a6aecfe992a11b3e0c","350":"bbb00e347160883f16f1","417":"64514d95c585c0361aba","419":"a317117857bd7b9995af","420":"23213822169d0c1d93cb","638":"1a28e182bc3530599a23","639":"69fc1c4b09af8609afcc","640":"44b0153d794ef2dd8a71"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2185);
